<template>
  <div class="relative">
    <input
      class="block w-full border-b border-gray-300 pt-4 px-2 outline-none focus:border-blackish"
      :type="type"
      :id="id ? id : nameToKebab"
      :name="nameToKebab"
      :value="value"
      @input="$emit('input', $event.target.value )"
      @change="$emit('change')"
      required
    >
    <label
      class="absolute text-sm text-blackish" :class="fontHairline()"
      :for="id ? id : nameToKebab"
    >
      {{ name }}
      <span v-if="brackets" class="text-xs italic pl-1">
        {{ brackets }}
      </span>
    </label>
    <span v-if="show" class="italic text-sm"
      :class="textColor ? textColor : 'text-b2c-red-300'">
      {{ messageToShow }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
    name: {},
    value: String,
    type: {
      default: 'text',
    },
    showMessage: Boolean,
    message: String,
    brackets: String,
    textColor: String,
  },

  data() {
    return {
      show: this.showMessage,
    };
  },

  watch: {
    value() {
      this.show = false;
      this.$emit('clear');
    },

    showMessage() {
      if (this.message) {
        this.show = this.showMessage;
        return;
      }
      this.show = (this.showMessage && !this.value);
    },
  },

  computed: {
    nameToKebab() {
      return this.toKebab(this.name);
    },
    messageToShow() {
      if (this.message) {
        return this.message;
      }
      return this.$t('input.fillField');
    },
  },

  methods: {
    toKebab(value) {
      return value.split(' ').join('-').toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  pointer-events:none;
  left: .5rem;
  top: 10px;
  transition:0.2s ease all;
}

input {
    transition:0.2s ease all;
}

input:focus ~ label, input:valid ~ label {
  @apply text-blackish font-normal;
  top: -15px;
}
</style>
